import { sample } from 'effector';
import queryString from 'query-string';
import {
  $createEditStatus,
  $mgpListFilters,
  $mgpPageList,
  $mgpsData,
  $mgpsModalState,
  $mgpTypeFilter,
  $nmpData,
  $nmpDataDup,
  $nmpFilters,
  $nmpFiltersDup,
  $selectedMgp,
} from './stores';
import {
  applyMgpFiltersEv,
  applyNMPFiltersDupEv,
  applyNMPFiltersEv,
  createMGPEv,
  deleteMGPEv,
  editMGPEv,
  EditMGPGate,
  MGPsGate,
  MGPsListGate,
  NMPGate,
  resetMgpFiltersEv,
  resetMGPsModalEv,
  resetNMPFiltersDupEv,
  resetNMPFiltersEv,
  setMGPsModalEv,
  setMgpTypeFilterEv,
} from './events';
import {
  createMGPFx,
  deleteMGPFx,
  editMGPFx,
  getMGPByIdFx,
  getMGPPageListFx,
  getMGPsListFx,
  getNMPDataDupFx,
  getNMPDataFx,
} from './effects';

$mgpsData
  .on(getMGPsListFx.doneData, (state, payload) => payload)
  .reset(MGPsGate.close);

$selectedMgp
  .on(getMGPByIdFx.doneData, (state, payload) => payload)
  .reset(resetMGPsModalEv);

$mgpsModalState
  .on(setMGPsModalEv, (state, payload) => ({ ...state, ...payload }))
  .reset(resetMGPsModalEv);

$createEditStatus
  .on(createMGPFx.doneData, () => true)
  .on(editMGPFx.doneData, () => true)
  .reset(resetMGPsModalEv);

$mgpPageList
  .on(getMGPPageListFx.doneData, (state, payload) => payload)
  .reset(MGPsListGate.close);

$mgpListFilters
  .on(applyMgpFiltersEv, (state, payload) => ({ ...state, ...payload }))
  .reset(resetMgpFiltersEv);

$mgpTypeFilter
  .on(setMgpTypeFilterEv, (state, payload) => payload)
  .reset(MGPsListGate.close);

$nmpData
  .on(getNMPDataFx.doneData, (_, payload) => payload)
  .reset(NMPGate.close);

$nmpDataDup
  .on(getNMPDataDupFx.doneData, (_, payload) => payload)
  .reset(NMPGate.close);

$nmpFilters
  .on(applyNMPFiltersEv, (state, payload) => ({ ...state, ...payload }))
  .reset(resetNMPFiltersEv);

$nmpFiltersDup
  .on(applyNMPFiltersDupEv, (state, payload) => ({ ...state, ...payload }))
  .reset(resetNMPFiltersDupEv);

sample({
  clock: [
    MGPsGate.open,
    createMGPFx.doneData,
    editMGPFx.doneData,
    deleteMGPFx.doneData,
  ],
  target: getMGPsListFx,
});

sample({
  clock: EditMGPGate.state,
  filter: ({ id }) => !!id,
  fn: ({ id }) => id,
  target: getMGPByIdFx,
});

sample({
  // source: {activities: $activitiesMap, regions: $regionsMap},
  clock: createMGPEv,
  // fn: ({activities, regions, districts}, values) => ({
  //   ...values,
  //   activity: activities[values.activity_id],
  //   region: regions[values.region_id]
  // }),
  target: createMGPFx,
});

sample({
  // source: {activities: $activitiesMap, regions: $regionsMap},
  clock: editMGPEv,
  // fn: ({activities, regions, districts}, values) => ({
  //   ...values,
  //   activity: activities[values.activity_id],
  //   region: regions[values.region_id],
  // }),
  target: editMGPFx,
});

sample({
  clock: deleteMGPEv,
  target: deleteMGPFx,
});

sample({
  clock: MGPsListGate.open,
  target: getMGPPageListFx,
});

sample({
  clock: $mgpListFilters.updates,
  fn: (filters) => {
    const checked = { ...filters };
    if (checked.gov_id && checked.gov_id.length > 0) {
      return { gov_id: checked.gov_id };
    }
    for (const [key, value] of Object.entries(checked)) {
      if (!value || value.length === 0) {
        delete checked[key];
      }
    }
    return checked;
  },
  target: getMGPPageListFx,
});

sample({
  clock: NMPGate.open,
  target: getNMPDataFx,
});

sample({
  clock: $nmpFilters.updates,
  fn: (filters) => queryString.stringify(filters),
  target: getNMPDataFx,
});

sample({
  clock: NMPGate.open,
  target: getNMPDataDupFx,
});

sample({
  clock: $nmpFiltersDup.updates,
  fn: (filters) => queryString.stringify(filters),
  target: getNMPDataDupFx,
});
